import React, { useEffect, useState } from "react";
import CourseService from "../../Api/CourseService";
import { Link, useNavigate } from "react-router-dom";

const CourseList = () => {
    const [courses, setCourses] = useState([]);
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [typeFilter, setTypeFilter] = useState('All');
    const courseService = new CourseService();
    const navigate = useNavigate();

    useEffect(() => {
        fetchCourses();
    }, []);

    const fetchCourses = async () => {
        try {
            const response = await courseService.GetAllCourse();
            if (response?.data?.data) {
                setCourses(response.data.data);
                setFilteredCourses(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching courses:", error);
        }
    };

    useEffect(() => {
        if (typeFilter === 'All') {
            setFilteredCourses(courses);
        } else {
            setFilteredCourses(courses.filter(course => course.type === typeFilter));
        }
    }, [typeFilter, courses]);

    // Helper to chunk array into rows of 3
    const chunkArray = (arr, size) => {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };

    return (
        <div id="courses" className="rbt-course-area rbt-section-gap bg-gradient-8 masonary-wrapper-activation">
            <div className="container">
                <div className="row row--15 align-items-center mb--60">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <h2 className="title color-white">
                                Latest <span className="color-white">Courses</span>
                            </h2>
                            <p className="description mt--20 color-white">
                                Are You Want to <strong>Change Your Life?</strong>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="rbt-portfolio-filter filter-button-default messonry-button text-center mb--30">
                            <button
                                className={typeFilter === 'All' ? 'is-checked' : ''}
                                onClick={() => setTypeFilter('All')}
                                type="button"
                            >
                                <span className="filter-text">All Types</span>
                            </button>
                            <button
                                className={typeFilter === 'Beginner' ? 'is-checked' : ''}
                                onClick={() => setTypeFilter('Beginner')}
                                type="button"
                            >
                                <span className="filter-text">Beginner</span>
                            </button>
                            <button
                                className={typeFilter === 'Advance' ? 'is-checked' : ''}
                                onClick={() => setTypeFilter('Advance')}
                                type="button"
                            >
                                <span className="filter-text">Advance</span>
                            </button>
                            <button
                                className={typeFilter === 'Expert' ? 'is-checked' : ''}
                                onClick={() => setTypeFilter('Expert')}
                                type="button"
                            >
                                <span className="filter-text">Expert</span>
                            </button>
                        </div>
                    </div>
                </div>
                {/* Start Card Area */}
                {filteredCourses.length === 0 ? (
                    <div className="row mb-4">
                        <div className="col-12 text-center text-white py-5">
                            <h4>No course available for the selected type.</h4>
                        </div>
                    </div>
                ) : (
                    chunkArray(filteredCourses, 3).map((row, rowIndex) => (
                        <div className="row mb-4" key={rowIndex}>
                            {row.map(course => (
                                <div className="col-md-4 mb-4" key={course.id}>
                                    <div className="rbt-card variation-01 rbt-hover">
                                        <div className="rbt-card-img">
                                            <Link to={`/coursedetailesview?id=${course.id}`}>
                                                <img
                                                    src={course.thumbnail_url}
                                                    alt={course.title}
                                                    style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                                />
                                                {course.price && (
                                                    <div className="rbt-badge-3 bg-white">
                                                        <span>₹{course.price}</span>
                                                    </div>
                                                )}
                                            </Link>
                                        </div>
                                        <div className="rbt-card-body">
                                            <ul className="rbt-meta">
                                                <li>
                                                    <i className="feather-calendar" />
                                                    {course.validity_days} Days
                                                </li>
                                                <li>
                                                    <i className="feather-users" />
                                                    {course.current_students}/{course.max_students} Students
                                                </li>
                                                <li>
                                                    <i className="feather-award" />
                                                    {course.type}
                                                </li>
                                            </ul>
                                            <h4 className="rbt-card-title">
                                                <Link to={`/coursedetailesview?id=${course.id}`}>{course.title}</Link>
                                            </h4>
                                            <p className="rbt-card-text">
                                                {course.description}
                                            </p>
                                            <div className="rbt-card-bottom">
                                                <div className="rbt-price">
                                                    <span className="current-price">₹{course.price}</span>
                                                </div>
                                                <button
                                                    className="rbt-btn-link btn btn-link p-0"
                                                    onClick={() => navigate(`/coursedetailesview?id=${course.id}`)}
                                                >
                                                    Learn More
                                                    <i className="feather-arrow-right" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default CourseList;
